import { ReactNode } from 'react';

import { Chip } from '@material-ui/core';

import { SidebarSection } from '@spotify/confidence-core-react';

import { METRIC_TYPE_OPTIONS, MetricType } from '../../metricTypes';

type TypeSectionProps = {
  metricType: MetricType;
  action?: ReactNode;
};

export const TypeSection = ({ metricType, action }: TypeSectionProps) => {
  const typeOption = METRIC_TYPE_OPTIONS.find(
    option => option.value === metricType,
  );

  return (
    <SidebarSection.Root>
      <SidebarSection.Header>
        <SidebarSection.Title>Type</SidebarSection.Title>
        {action && <SidebarSection.Action>{action}</SidebarSection.Action>}
      </SidebarSection.Header>
      <SidebarSection.Content>
        <Chip label={typeOption?.title ?? 'Unknown'} />
      </SidebarSection.Content>
    </SidebarSection.Root>
  );
};
